export default {
  loadedOrders(state) {
    return (state.list || []).filter((order) => !!order.details);
  },
};
